import { render } from "./MenuSideBar.vue?vue&type=template&id=fe29569a"
import script from "./MenuSideBar.vue?vue&type=script&lang=js"
export * from "./MenuSideBar.vue?vue&type=script&lang=js"

import "./MenuSideBar.vue?vue&type=style&index=0&id=fe29569a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__